import { useEffect, useMemo, useState } from "react";

import { normalizeDate } from "@ui/utils/formatDate/normalizeDate";

const DAY_IN_MS = 1000 * 60 * 60 * 24;
const HOUR_IN_MS = 1000 * 60 * 60;
const MINUTE_IN_MS = 1000 * 60;
const SECOND_IN_MS = 1000;

const padNumber = (num: number): string => {
  return num.toString().padStart(2, "0");
};

export const useCountdown = (date?: string | Date) => {
  const targetDate = useMemo(() => (date ? normalizeDate(date) : null), [date]);
  const [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    if (!date) {
      return;
    }

    const updateCounter = () => {
      if (!targetDate) return;
      const now = new Date();
      const remainingMs = Math.max(targetDate.getTime() - now.getTime(), 0);
      setTimeLeft(remainingMs);
    };

    updateCounter();
    const interval = setInterval(updateCounter, 1000);
    return () => clearInterval(interval);
  }, [date, targetDate]);

  return {
    timeLeft: {
      days: padNumber(Math.floor((timeLeft ?? 0) / DAY_IN_MS)),
      hours: padNumber(Math.floor(((timeLeft ?? 0) % DAY_IN_MS) / HOUR_IN_MS)),
      minutes: padNumber(Math.floor(((timeLeft ?? 0) % HOUR_IN_MS) / MINUTE_IN_MS)),
      seconds: padNumber(Math.floor(((timeLeft ?? 0) % MINUTE_IN_MS) / SECOND_IN_MS)),
    },
    shouldShowCounter: timeLeft !== null,
  };
};
